export interface ProjectPricingCategory {
  id: string;
  name: string;
  description: string;
  items: ProjectPricingItem[];
}
export interface ProjectPricingItem {
  id: string;
  name: string;
  description: string;
  priceUsd: number;
}
export interface ProjectPricing {
  categories: ProjectPricingCategory[];
}
export const projectPricing: ProjectPricing = {
  categories: [
    {
      id: "cat_1",
      name: "Platform",
      description: "Choose the platform for your app",
      items: [
        // {
        //   id: "item_1_1",
        //   name: "iOS only",
        //   description: "Build for iOS platform",
        //   priceUsd: 5000,
        // },
        // {
        //   id: "item_1_2",
        //   name: "Android only",
        //   description: "Build for Android platform",
        //   priceUsd: 5000,
        // },
        {
          id: "item_1_3",
          name: "Cross-platform",
          description: "Build for both iOS and Android platforms",
          priceUsd: 3900,
        },
        {
          id: "item_1_4",
          name: "Web",
          description: "Build a web app for mobile browsers",
          priceUsd: 1800,
        },
        // {
        //   id: "item_1_5",
        //   name: "iOS, Android, Web",
        //   description: "Build for iOS, Android, and Web platforms",
        //   priceUsd: 12000,
        // },
      ],
    },
    {
      id: "cat_2",
      name: "User Interface and Design",
      description: "Design the user interface and experience",
      items: [
        {
          id: "item_2_1",
          name: "Basic",
          description: "Basic in house design",
          priceUsd: 1500,
        },
        {
          id: "item_2_2",
          name: "Template-based",
          description:
            "Create a unique design tailored to your brand and requirements.",
          priceUsd: 2000,
        },
        // {
        //   id: "item_2_3",
        //   name: "Custom",
        //   description: "Highly interactive and customized design solution.",
        //   priceUsd: 6000,
        // },
        {
          id: "item_2_4",
          name: "I have my own Design",
          description: "I will provide my own design",
          priceUsd: 2000,
        },
        {
          id: "item_2_5",
          name: "Up to 5 screens",
          description: "Build up to 5 screens in the app",
          priceUsd: 0,
        },
        {
          id: "item_2_6",
          name: "5 to 10 screens",
          description: "Build between 5 to 10 screens in the app",
          priceUsd: 1500,
        },
      ],
    },
    {
      id: "cat_3",
      name: "Authentication and User Management",
      description: "Implement user authentication and management features",
      items: [
        {
          id: "item_3_1",
          name: "User Login & Registration",
          description: "Email and password authentication",
          priceUsd: 1000,
        },
        {
          id: "item_3_2",
          name: "Roles & Permissions",
          description:
            "Implement user roles and permissions for access control",
          priceUsd: 1000,
        },
        {
          id: "item_3_3",
          name: "Single Sign-On (SSO)",
          description: "Integrate with third-party identity providers for SSO",
          priceUsd: 1000,
        },
        {
          id: "item_3_4",
          name: "Social Login",
          description: "Allow users to log in with social media accounts",
          priceUsd: 1500,
        },
      ],
    },
    {
      id: "cat_4",
      name: "Core Features",
      description: "Choose the core features for your app",
      items: [
        {
          id: "item_4_1",
          name: "Push Notifications",
          description: "Push notifications to engage users",
          priceUsd: 2000,
        },
        // {
        //   id: "item_4_2",
        //   name: "In-app Messaging",
        //   description: "Send messages to users within the app",
        //   priceUsd: 1500,
        // },
        {
          id: "item_4_3",
          name: "Location Tracking",
          description: "Integrate location-based features",
          priceUsd: 2000,
        },
        {
          id: "item_4_4",
          name: "Maps Integration",
          description: "Integrate maps to display pins or user location",
          priceUsd: 1500,
        },
        {
          id: "item_4_5",
          name: "Payment Integration (Cybersource or PayPal or Stripe)",
          description: "Integrate payment gateways for in-app purchases",
          priceUsd: 2500,
        },
        {
          id: "item_4_6",
          name: "Payment Subscription (Stripe, Apple Pay, Google Pay)",
          description: "Integrate in-app subscription-based payments",
          priceUsd: 2500,
        },
        {
          id: "item_4_7",
          name: "Remote Logs",
          description: "Integrate remote logging for monitoring and debugging",
          priceUsd: 800,
        },
        {
          id: "item_4_8",
          name: "Analytics",
          description:
            "Integrate analytics tools to track user behavior and app performance",
          priceUsd: 900,
        },
        {
          id: "item_4_9",
          name: "Local database (offline)",
          description: "Implement local database for offline data storage",
          priceUsd: 500,
        },
        {
          id: "item_4_10",
          name: "Cloud database (online)",
          description:
            "Integrate cloud database for real-time data synchronization",
          priceUsd: 900,
        },
        {
          id: "item_4_11",
          name: "Data synchronization",
          description:
            "Implement data synchronization between local and cloud databases",
          priceUsd: 900,
        },
        {
          id: "item_4_12",
          name: "Multi-language (i18n)",
          description:
            "Implement multi-language support for internationalization",
          priceUsd: 800,
        },
        {
          id: "item_4_13",
          name: "Admin Dashboard",
          description:
            "Develop an admin dashboard for managing app content and users",
          priceUsd: 2000,
        },
        {
          id: "item_4_14",
          name: "API Integrations",
          description:
            "Integrate with third-party APIs for additional functionality",
          priceUsd: 2000,
        },
        {
          id: "item_4_15",
          name: "Data Export / Import (from local database)",
          description:
            "Implement data export and import functionality for local database",
          priceUsd: 800,
        },
      ],
    },
    {
      id: "cat_5",
      name: "Backend Infrastructure",
      description: "Choose the backend infrastructure for your app",
      items: [
        {
          id: "item_5_1",
          name: "I need to build an API",
          description:
            "Build an intermediate complexity API based on my specifications.",
          priceUsd: 3000,
        },
        {
          id: "item_5_2",
          name: "I have an API ready",
          description: "I have and API, I will provide keys and documentation.",
          priceUsd: 1000,
        },
        {
          id: "item_5_3",
          name: "Use cloud provider such as supabase or firebase",
          description: "I would like to integrate with supabase/firebase.",
          priceUsd: 1000,
        },
      ],
    },
    {
      id: "cat_6",
      name: "App Administration",
      description: "Choose the app administration and maintenance plan",
      items: [
        {
          id: "item_6_1",
          name: "Basic dashboard",
          description:
            "Basic dashboard with essential features for app management.",
          priceUsd: 1000,
        },
        // {
        //   id: "item_6_2",
        //   name: "Intermediate dashboard",
        //   description:
        //     "Intermediate dashboard with additional features and analytics.",
        //   priceUsd: 2000,
        // },
        {
          id: "item_6_3",
          name: "Advanced system",
          description:
            "Advanced system with comprehensive features and support.",
          priceUsd: 3000,
        },
      ],
    },
    {
      id: "cat_7",
      name: "Launch",
      description: "Choose the launch and post-launch support plan",
      items: [
        {
          id: "item_7_1",
          name: "Assisted launch",
          description:
            "Assistance with app store submission and launch. Screenshots/icons/descriptions not included",
          priceUsd: 500,
        },
        {
          id: "item_7_2",
          name: "We launch",
          description:
            "We will submit and launch your app. Plus 1 month of post-launch support.",
          priceUsd: 2000,
        },
        // {
        //   id: "item_7_3",
        //   name: "Premium launch",
        //   description:
        //     "Comprehensive launch support plus 3 months of post-launch support.",
        //   priceUsd: 3000,
        // },
      ],
    },
  ],
};
